var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreenShot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.971,
    viewBox: "0 0 20 20.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screen_Shot",
    "data-name": "Screen Shot",
    transform: "translate(-4413 -9555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3018",
    "data-name": "Group 3018",
    transform: "translate(4415.535 9558.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2372",
    "data-name": "Rectangle 2372",
    fill: "none",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3017",
    "data-name": "Group 3017",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M-4634.345-9516.317h-4.191l3.928-7,2.257,4.019,1.411-2.108,3.4,5.09Zm1.81-8.5a1.5,1.5,0,0,1,1.5-1.5,1.5,1.5,0,0,1,1.5,1.5,1.5,1.5,0,0,1-1.5,1.5A1.5,1.5,0,0,1-4632.535-9524.816Z",
    transform: "translate(4638.535 9526.317)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M2,6H.571C.256,6,0,5.855,0,5.676V.324C0,.145.256,0,.571,0H6c.315,0,.572.145.572.324V1.459h-4C2.256,1.459,2,1.6,2,1.784V6Z",
    transform: "translate(4413 9555)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M3.931,6H5.159c.271,0,.491-.145.491-.324V.324C5.651.145,5.43,0,5.159,0H.492C.221,0,0,.145,0,.324V1.459H3.44c.271,0,.491.145.491.324V6Z",
    transform: "translate(4427.349 9555)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M2,0H.571C.256,0,0,.164,0,.365V6.4c0,.2.256.365.571.365H6c.315,0,.572-.164.572-.365V5.117h-4C2.256,5.117,2,4.953,2,4.752V0Z",
    transform: "translate(4413 9569.209)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M3.931,0H5.159c.271,0,.491.164.491.365V6.4c0,.2-.22.365-.491.365H.492C.221,6.762,0,6.6,0,6.4V5.117H3.44c.271,0,.491-.164.491-.365V0Z",
    transform: "translate(4427.349 9569.209)",
    fill: "current"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShot);
export default __webpack_public_path__ + "static/media/Screen-Shot.51076354c3a133a81ccb8d8594314b5b.svg";
export { ForwardRef as ReactComponent };